var _circle, _circle2, _circle3, _path, _rect, _rect2, _rect3, _rect4, _path2, _path3, _rect5, _rect6, _rect7, _rect8, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 48,
    fill: "#F7F7F8",
    stroke: "#EEEEF0",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 36,
    stroke: "#EEEEF0",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 24,
    stroke: "#EEEEF0",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.8574 31.4878H39.8574C36.5437 31.4878 33.8574 34.1741 33.8574 37.4878V89.4878C33.8574 92.8015 36.5437 95.4878 39.8574 95.4878H83.3721C84.9634 95.4878 86.4896 94.8556 87.6148 93.7304L104.1 77.2451C105.225 76.1199 105.857 74.5938 105.857 73.0025V37.4878C105.857 34.1741 103.171 31.4878 99.8574 31.4878Z",
    fill: "#F7F7F8",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.8574,
    y: 59.4878,
    width: 56,
    height: 6,
    rx: 3,
    fill: "#D9D9DE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61.8574,
    y: 39.4878,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#D9D9DE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61.8574,
    y: 49.4878,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#D9D9DE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 41.8574,
    y: 39.4878,
    width: 16,
    height: 16,
    rx: 3,
    fill: "#D9D9DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.1 77.2451L87.6147 93.7304C86.7269 94.6182 85.5895 95.199 84.3675 95.4046C83.8229 95.4962 83.3721 95.04 83.3721 94.4877V79.0024C83.3721 75.6887 86.0584 73.0024 89.3721 73.0024H104.857C105.41 73.0024 105.866 73.4532 105.774 73.9979C105.569 75.2199 104.988 76.3573 104.1 77.2451Z",
    fill: "#D9D9DE",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.316 41.0821L50.36 25.5529C47.1592 24.6953 43.8692 26.5948 43.0115 29.7956L29.5529 80.0237C28.6953 83.2245 30.5948 86.5145 33.7956 87.3722L75.8276 98.6346C77.3647 99.0465 79.0024 98.8309 80.3805 98.0352L100.571 86.3783C101.949 85.5827 102.954 84.2722 103.366 82.7351L112.558 48.4305C113.416 45.2297 111.516 41.9397 108.316 41.0821Z",
    fill: "white",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 45.0449,
    y: 53.1165,
    width: 56,
    height: 6,
    rx: 3,
    transform: "rotate(15 45.0449 53.1165)",
    fill: "#EEEEF0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 69.54,
    y: 38.9741,
    width: 36,
    height: 6,
    rx: 3,
    transform: "rotate(15 69.54 38.9741)",
    fill: "#EEEEF0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 66.9521,
    y: 48.6335,
    width: 36,
    height: 6,
    rx: 3,
    transform: "rotate(15 66.9521 48.6335)",
    fill: "#EEEEF0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 50.2217,
    y: 33.7979,
    width: 16,
    height: 16,
    rx: 3,
    transform: "rotate(15 50.2217 33.7979)",
    fill: "#EEEEF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.571 86.3784L80.3808 98.0352C79.2934 98.663 78.0445 98.9297 76.8109 98.812C76.2611 98.7595 75.9437 98.2022 76.0867 97.6687L80.0945 82.7111C80.9522 79.5103 84.2422 77.6108 87.443 78.4684L102.401 82.4763C102.934 82.6193 103.258 83.1728 103.029 83.6751C102.514 84.8023 101.658 85.7506 100.571 86.3784Z",
    fill: "#EEEEF0",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5185 75.6198V84.963C66.5185 85.5152 66.0708 85.963 65.5185 85.963H56.1754C55.1145 85.963 54.0971 85.5415 53.3469 84.7914L52.5186 83.963L22.5186 53.963L19.5186 50.963L16.0442 47.4887C14.9032 46.3476 14.8691 44.5084 15.9671 43.326L23.4372 35.2813C24.5942 34.0353 26.5545 33.999 27.7569 35.2013L31.5186 38.963L34.5186 41.963L64.5186 71.963L65.3469 72.7914C66.0971 73.5415 66.5185 74.559 66.5185 75.6198Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5186 83.963L53.3469 84.7914C54.0971 85.5415 55.1145 85.963 56.1754 85.963H65.5185C66.0708 85.963 66.5185 85.5152 66.5185 84.963V75.6198C66.5185 74.559 66.0971 73.5415 65.3469 72.7914L64.5186 71.963M52.5186 83.963L55.5186 80.963L58.5186 77.963L61.5186 74.963L64.5186 71.963M52.5186 83.963L22.5186 53.963M64.5186 71.963L34.5186 41.963M19.5186 50.963L16.0442 47.4887C14.9032 46.3476 14.8691 44.5084 15.9671 43.326L23.4372 35.2813C24.5942 34.0353 26.5545 33.999 27.7569 35.2013L31.5186 38.963M19.5186 50.963L31.5186 38.963M19.5186 50.963L22.5186 53.963M31.5186 38.963L34.5186 41.963M22.5186 53.963L34.5186 41.963",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5186 77.9629L28.5186 47.9629M55.5186 80.9629L25.5186 50.9629M61.5186 74.9629L31.5186 44.9629",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8114 39.67L20.2257 50.2558C19.8351 50.6463 19.8351 51.2795 20.2257 51.67L21.8114 53.2558C22.202 53.6463 22.8351 53.6463 23.2257 53.2558L33.8114 42.67C34.202 42.2795 34.202 41.6463 33.8114 41.2558L32.2257 39.67C31.8351 39.2795 31.202 39.2795 30.8114 39.67Z",
    fill: "#F7F7F8",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9327 85.3771L53.2257 84.67C52.8351 84.2795 52.8351 83.6463 53.2257 83.2558L55.5186 80.9629L58.5186 77.9629L61.5186 74.9629L63.8114 72.67C64.202 72.2795 64.8351 72.2795 65.2257 72.67L65.9327 73.3771C66.3078 73.7521 66.5185 74.2609 66.5185 74.7913V81.9629V84.9629C66.5185 85.5151 66.0708 85.9629 65.5185 85.9629H62.5186H55.3469C54.8165 85.9629 54.3078 85.7521 53.9327 85.3771Z",
    fill: "#F7F7F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5186 85.9629H65.5185C66.0708 85.9629 66.5185 85.5151 66.5185 84.9629V81.9629M62.5186 85.9629H55.3469C54.8165 85.9629 54.3078 85.7521 53.9327 85.3771L53.2257 84.67C52.8351 84.2795 52.8351 83.6463 53.2257 83.2558L55.5186 80.9629L58.5186 77.9629L61.5186 74.9629L63.8114 72.67C64.202 72.2795 64.8351 72.2795 65.2257 72.67L65.9327 73.3771C66.3078 73.7521 66.5185 74.2609 66.5185 74.7913V81.9629M62.5186 85.9629L66.5185 81.9629",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9328 85.9629H65.5185C66.0708 85.9629 66.5185 85.5151 66.5185 84.9629V84.3771C66.5185 83.4862 65.4414 83.04 64.8114 83.67L64.2257 84.2557C63.5957 84.8857 64.0419 85.9629 64.9328 85.9629Z",
    fill: "#B9BAC0",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9671 43.326L23.4372 35.2813C24.5942 34.0353 26.5545 33.999 27.7569 35.2013L30.8114 38.2559C31.202 38.6464 31.202 39.2796 30.8114 39.6701L20.2257 50.2559C19.8351 50.6464 19.202 50.6464 18.8114 50.2559L16.0442 47.4887C14.9032 46.3476 14.8691 44.5084 15.9671 43.326Z",
    fill: "#D9D9DE",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.d517b03f9aed749622c121da9cd1a53c.svg";
export { ForwardRef as ReactComponent };